/* Fransk katalog for locale-supplier-country-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  "purchaseDocs.removeAll": "Tout retirer",
  "purchaseDocs.removeOne": "Retirer {name} de cet achat",
  "purchaseDocs.duplicateTitle": "Écriture potentiellement en double",
  "purchaseDocs.duplicateHelp": "Vérifiez les achats précédents. Vous pouvez quand même comptabiliser.",
  "purchaseDocs.sameAttachment": "Le même fichier est joint plusieurs fois.",
  "purchaseDocs.sameFile": "Le même fichier est utilisé pour la pièce {number} · {date}.",
  "purchaseDocs.sameDetails": "La pièce {number} · {date} a la même date et le même montant.",
  "purchaseFlow.listTitle": "Liste des achats",
  "purchaseFlow.purchaseCount": "Achats",
  "purchaseFlow.netPurchases": "Achats nets",
  "purchaseFlow.netPurchasesHelp": "Hors TVA, après avoirs",
  "purchaseFlow.includingVat": "TVA comprise",
  "purchaseFlow.credited": "Crédité",
  "purchaseFlow.creditable": "Montant encore créditable",
  "purchaseFlow.creditAllocationHelp": "Sélectionnez la facture avant comptabilisation pour une imputation automatique. Le montant dépassant le solde impayé reste un avoir fournisseur.",
  "err.supplierCredit.invalidAmount": "Le montant doit être positif et ne peut dépasser le montant pas encore crédité. Les paiements ne réduisent pas cette limite.",
  "err.purchase.duplicateSupplierDocument": "Ce numéro de document existe déjà pour ce fournisseur. Ouvrez la facture ou l’avoir existant.",
  'purchaseFlow.creditNote': 'Avoir',
  "purchaseFlow.negativeWarning": "Un montant de facture négatif est inhabituel, sauf pour un avoir.",
  "purchaseFlow.creditOriginal": "Facture créditée (facultatif)",
  "purchaseFlow.standaloneCredit": "Sans lien – avoir auprès du fournisseur",
  "purchaseFlow.creditLinesRequired": "Utilisez de nouvelles lignes négatives et comptabilisez directement. Les brouillons et modifications ne sont pas pris en charge ici.",
  "err.supplierCredit.unsupportedLines": "Utilisez des lignes d’achat ordinaires. Les stocks, immobilisations et traitements particuliers de TVA nécessitent une correction dédiée.",
  'registry.toggleSupplierHelp': 'Suggère des entreprises norvégiennes pendant que vous saisissez le nom du fournisseur ou le numéro d\'organisation.',
  'sup.foreignToggle': 'Fournisseur étranger',
  'sup.foreignToggleHelp': 'Activez pour les fournisseurs immatriculés dans un autre pays que celui de votre entreprise.',
  'sup.countryCode': 'Code pays',
  'sup.countryCodePh': 'Ex. SE ou US',
  'sup.countryRequired': 'Saisissez un code pays à deux lettres pour le fournisseur étranger.',
  'sup.registrationNumber': 'Numéro d\'immatriculation',
  'sup.registrationNumberPh': 'Numéro d\'immatriculation étranger du fournisseur',
  'sup.vatNumber': 'Numéro de TVA',
  'sup.vatNumberPh': 'Ex. SE123456789001',
});
